import EventCalendar from "../../components/eventCalendar/eventCalendar";
import { events } from "../../global/API";

const CalendarAppointments = () => {
  return (
    <div className="page-content calendar-page">
      <div className="container-fluid">
        <div className="calendar-grid">
          <EventCalendar events={events} />
        </div>
      </div>
    </div>
  );
};

export default CalendarAppointments;
